/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import "react-reflex/styles.css";
import layoutConf from "../../config/layoutConf";
import CommonCodeMst from "./CommonCodeMst";
import CommonCodeSlave from "./CommonCodeSlave";
/**
 * @COMPONENT_NAME CommonCodeManager
 * @DESCRIPTION 공통코드 마스터 관리와 공통코드 슬레이브 관리를 위한 화면으로 수평분할로 구성되었습니다.
 *
 *
 * @PASSTHROUGH_PROPS
 *   - {Object} schema - 하위 컴포넌트에 전달 될 테이블 스키마 정보
 *   - {Object} grid - 하위 컴포넌트에 전달 될 그리드 객체 참조
 *   - {Object} refresh - 하위 컴포넌트에 전달 될 API refresh 객체
 *   - {Function} onSuccess - 하위 컴포넌트에 전달 될 작업 성공 시 콜백
 *   - {Function} onFailure - 하위 컴포넌트에 전달 될 작업 실패 시 콜백
 *   - {Function} onNotifyWarning - 하위 컴포넌트에 전달 될 경고 알림 콜백
 *   - {String} call - 마스터 테이블 수정 시 setCall에 의해 수정된 call이 슬레이브 컴포넌트로 전달됨
 * 	 - {Function} setCall - 마스터 테이블 수정 시 setCall이 호출됨
 * @CALLBACKS
 *   - {Function} handleCommonCodeMstSelect - 마스터 그리드 선택시 호출되는 콜백
 *   - {Function} notifySuccess - 성공 알림을 표시하는 콜백
 *   - {Function} notifyFailure - 실패 알림을 표시하는 콜백
 *   - {Function} notifyWarning - 경고 알림을 표시하는 콜백
 *   - {Function} onApiInitialized - API 초기화 시 호출되는 콜백
 *   - {Function} onInitialized - 그리드 초기화 시 호출되는 콜백
 */

const CommonCodeManager = () => {
	const [height, setHeight] = useState(0);
	const [selectedmst, setSelectedmst] = useState();
	const [call, setCall] = useState(0);
	const handleResize = () => {
		setHeight(document.documentElement.offsetHeight - 96);
	};

	useEffect(() => {
		window.addEventListener("resize", handleResize);
		handleResize();
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const handleCommonCodeMstSelect = (mst) => {
		// mst의 그리드를 선택할 때마다 selectMst를 갱신
		setSelectedmst(mst ? mst : null);
	};

	return (
		<div style={{ height: height }}>
			<ReflexContainer orientation="horizontal">
				<ReflexElement flex={0.5}>
					<CommonCodeMst
						onSelect={handleCommonCodeMstSelect}
						setCall={setCall}
					/>
				</ReflexElement>

				<ReflexSplitter
					style={{ height: layoutConf.reflex.splitterHeight }}
				/>

				<ReflexElement flex={0.5}>
					<CommonCodeSlave
						selectedmst={selectedmst}
						call={call}
					/>
				</ReflexElement>
			</ReflexContainer>
		</div>
	);
};

export default CommonCodeManager;
